// @ts-nocheck
import * as $ from 'jquery';
import { NotificationType } from "Common/NotificationManager";
import { PreviewRequest } from "./Models/PreviewRequest";
import Mediator from 'Common/Mediator';


export class SurveyPageMultipleApplication {
    private currentContainer: JQuery;
    private checkoutButton: JQuery;
    private loader: JQuery;
    private timeout: any;
    private isSearching: boolean;
    private backButton: JQuery;
    private searchInput: JQuery;
    private filterSurveyNumber: JQuery;
    private filterSurveyYear: JQuery;
    private filterSurveyStatus: JQuery;
    private filterSurveyOrganizationGroup: JQuery;
    private apiUrl: string;
    private organizationListTableBody: JQuery;
    private selectedIds: any[];
    private proceedText: string;
    private proceed: JQuery;
    private proceedButtons: JQuery;
    private previewListTableBody: JQuery;
    private previewText: string;
    private previewSummary: JQuery;
    private confirmButton: JQuery;
    private form: JQuery;
    private successfulText: string;
    private unsuccessfulText: string;

    constructor(private container: JQuery) {
        let that = this;
        $('.results-survey').hide();
        $('.preview-survey').hide();
        this.currentContainer = container;
        this.form = container.find('.ajax-form');
        this.apiUrl = container.attr('data-api-root-prefix');
        this.proceedText = container.attr('data-proceed-step-text');
        this.previewText = container.attr('data-preview-text');
        this.successfulText = container.attr('data-successful-text');
        this.unsuccessfulText = container.attr('data-unsuccessful-text');
        
        this.searchInput = container.find('#Search');
        this.filterSurveyNumber = container.find('#FilterSurveyNumber');
        this.filterSurveyYear = container.find('#FilterSurveyYear');
        this.filterSurveyStatus = container.find('#FilterSurveyStatus');
        this.filterSurveyOrganizationGroup = container.find('#FilterSurveyOrganizationGroup');
        this.loader = container.find('.section-loader');
        this.loader.hide();
        this.proceed = container.find('.proceed-selected').html(this.proceedText);
        this.proceed.hide();
        
        this.organizationListTableBody = container.find('#organization-list-tbody');
        this.organizationListTableBody
            .on('click', '.select-checkbox', (event) => this.clickCheckBox(event));

        this.previewListTableBody = container.find('#organization-preview-tbody');
        this.previewSummary = container.find('.preview-summary-text').html(this.previewText);
        this.loader = container.find('.section-loader');
        
        this.loader.hide();
        this.selectedIds = [];
        this.proceedButtons = $('.add-selected-organizations-button');
        this.proceedButtons.each(function () {
            let button = $(this);
            button.on('click', (event) => that.showPreview());
        });
        
        this.confirmButton = $('.confirm-selected-organizations-button');
        this.confirmButton.on('click', function(e){
            if(confirm($(e.currentTarget).attr('data-confirm-message'))) {
                that.saveSelections(e);
            }
        });

        this.backButton = $('.back-to-select');
        this.backButton.on('click', function(evt) {
            $('.choose-organizations').show();
            $('.preview-survey').hide();
        })
      
        this.initialize();
    }

    clickCheckBox(evt: JQueryEventObject): void {
        let target = $(evt.currentTarget);
        let checked = target.is(":checked");
        let type = 'add';
        let tr = target.closest('tr');
        let id = tr.data('organization-id');

        if (target.is('[data-adjust-all]')) {
            this.loader.show();
            this.selectAll(target, type);
            return;
        } else {
            tr.data('has-changed', true);
        }

        let index = this.selectedIds.indexOf(id);
        if (checked) {
            if (index === -1) {
                this.selectedIds.push(id);
            }
        } else {
            if (index >= 0) {
                this.selectedIds.splice(index, 1);
            }
        }
        this.updateSelectedState();
    }

    selectAll(checkbox: JQuery, type: string) {
        let container = checkbox.parent();
        let value = checkbox.is(':checked');
        let trs = container.closest('tbody').find('tr');

        let section = this;
        trs.not('[data-adjust-all]').each(function () {
            $(this).data('has-changed', true);
            $(this).find('input.select-checkbox').click();
        });

        section.loader.hide();
    }

    updateSelectedState() {
        var enabled = this.selectedIds.length > 0;
        let that = this;
        this.proceedButtons.each(function (e) {
            let button = $(this);
            button.prop('disabled', !enabled);
            button.html(that.proceedText.replace('{0}', that.selectedIds.length.toString()))
        });
    }

    searchOrganizations(append?: boolean, page?: number): void {
        if (!this.isSearching) {
            const that = this;
            let query = this.searchInput.val();
            let surveyNumberFilter = this.filterSurveyNumber.val();
            let surveyYearFilter = this.filterSurveyYear.val();
            let surveyStatusFilter = this.filterSurveyStatus.val();
            let surveyOrganizationGroupFilter = this.filterSurveyOrganizationGroup.val();
            const pageSize = 1000;

            this.timeout = setTimeout(function () {
                let searchUrl = that.apiUrl + "search" +
                    `?ps=${pageSize}`;
                if (page) {
                    searchUrl += `&p=${page}`;
                }

                if (query && query.length > 2) {
                    searchUrl += `&q=${query}`;
                }

                if (surveyNumberFilter && surveyNumberFilter !== '' && surveyNumberFilter.length > 0) {
                    searchUrl += `&sn=${surveyNumberFilter}`;
                }

                if (surveyYearFilter && surveyYearFilter !== '' && surveyYearFilter.length > 0) {
                    searchUrl += `&sy=${surveyYearFilter}`;
                }

                if (surveyStatusFilter && surveyStatusFilter !== '' && surveyStatusFilter.length > 0) {
                    searchUrl += `&ss=${surveyStatusFilter}`;
                }

                if (surveyOrganizationGroupFilter && surveyOrganizationGroupFilter !== '' && surveyOrganizationGroupFilter.length > 0) {
                    searchUrl += `&og=${surveyOrganizationGroupFilter}`;
                }

                that.isSearching = true;
                that.loader.show();

                if (!append) {
                    that.organizationListTableBody.empty();
                }
                $.ajax({
                    url: searchUrl,
                    dataType: 'json',
                    success: function (data) {
                        if (data && data.length >= 0) {
                            let i;

                            if (data.length <= 1000) {
                                let allRow = that.createSelectAllRow();
                                that.organizationListTableBody.append(allRow);
                            }

                            for (i = 0; i < data.length; i = i + 1) {
                                let organization = data[i];
                                let row = that.createOrganizationRow(organization);
                                that.organizationListTableBody.append(row);
                            }
                        }
                        that.loader.hide();
                        that.isSearching = false;
                    }
                });
            });
        }
    }

    createSelectAllRow(): JQuery {
        let row = $('<tr data-adjust-all />');
        row.append($('<td/>').text('Alle'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        row.append($('<td/>'));
        row.append($('<td class="select center" />').html(this.getCheckBox(false, true)));
        return row;
    }

    private getCheckBox(checked: boolean, isSelectAll?: boolean) {
        return `<input type="checkbox" name="selectedOrganizations" class="select-checkbox" ${checked ? 'checked' : ''} ${isSelectAll ? 'data-adjust-all' : ''} />`;
    }

    createOrganizationRow(organization: any): JQuery {
        let row = $(`<tr data-organization-name='${organization.Name}' +
            ' data-organization-id='${organization.Id}' +
            ' data-has-changed='false' />`);
        row.append($('<td/>').text(" "));
        row.append($('<td/>').text(organization.Name));
        if (organization.LatestSurvey) {
            var number = `RVU${organization.LatestSurvey?.SurveyNumber}`;
            row.append($('<td/>').text(number));
            row.append($('<td/>').text(organization.LatestSurvey?.ShortStartDate ?? ""));
            row.append($('<td/>').text(organization.LatestSurveyState ?? ""));
        } else {
            row.append($('<td/>').html("<span class='center-block'>-</span>"));
            row.append($('<td/>').html("<span class='center-block'>-</span>"));
            row.append($('<td/>').html("<span class='center-block'>-</span>"));
        }
        row.append($('<td/>').text(organization.OrganizationGroup));

        let checked = this.selectedIds?.includes(organization.Id) ?? false;
        row.append($('<td class="select center" />').html(this.getCheckBox(checked)));
        return row;
    }

    createPreviewRow(organization: any): JQuery {
        let row = $(`<tr />`);
        row.append($('<td/>').text(organization.Name));
        var number = `RVU${organization.NextTravelSurveyNumber}`;
        row.append($('<td/>').text(number));
        row.append($('<td/>').text(organization.EmployeeCount));
        return row;
    }

    showPreview() {
        var req = new PreviewRequest(this.selectedIds);
        this.previewListTableBody.empty();
        let that = this;
        $.ajax({
            url: this.apiUrl + "preview",
            data: req,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                let selectedOrganizations = 0;
                let totalEmployees = 0;
                if (data && data.length >= 0) {
                    let i;

                    for (i = 0; i < data.length; i = i + 1) {
                        let organization = data[i];
                        let row = that.createPreviewRow(organization);
                        that.previewListTableBody.append(row);
                        selectedOrganizations++;
                        totalEmployees = totalEmployees + organization.EmployeeCount;
                    }
                }

                let summaryText = that.previewText.replace("{0}", selectedOrganizations.toString())
                    .replace("{1}", totalEmployees.toString())

                that.previewSummary.html(summaryText);
                that.loader.hide();
            },
            error: function (data) {
                const json = data.responseJSON;
                let message = json.Message;
                if (!message) {
                    message = `${json.status} ${json.title}`;
                }
                Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
            }
        });

        $('.choose-organizations').hide();
        $('.preview-survey').show();
    }

    createResultsRow(organization: any): JQuery {
        let row = $(`<tr />`);
        row.append($('<td/>').text(organization.Name));
        
        let s = "";
        if(organization.Success) {
            s = this.successfulText;
        }else{
            s= this.unsuccessfulText;
        }
        row.append($('<td/>').text(s));
        return row;
    }
    
    public saveSelections(evt: JQueryEventObject) {
        let application = this;
        let tbody =$("#organization-results-tbody");
        tbody.empty();
        let that = this;
        $('.preview-survey').hide();
        this.loader.show();
        var shouldSend = $(".shouldSendEmail").is(":checked");
        var req = new PreviewRequest(this.selectedIds, shouldSend);
        $.ajax({
            url: this.apiUrl + "save",
            data: req,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (data && data.Organizations.length >= 0) {
                    let i;
                    var orgs = data.Organizations;
                    for (i = 0; i < orgs.length; i = i + 1) {
                        let organization = orgs[i];
                        let row = that.createResultsRow(organization);
                        tbody.append(row);
                    }
                }
                that.loader.hide();
                $('.results-survey').show();
                Mediator.instance.publish('notification:show', that.successfulText, NotificationType.Success, true);
            },
            error: function (data) {
                const json = data.responseJSON;
                let message = json.Message;
                if (!message) {
                    message = `${json.status} ${json.title}`;
                }

                that.loader.hide();
                Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
            }
        });
    }

    searchChanged(evt: JQueryEventObject): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.searchOrganizations();
    }

    private initialize() {
        this.searchOrganizations();
        this.searchInput.on('keyup', (event) => this.searchChanged(event));
        this.filterSurveyNumber.on('change', (event) => this.searchChanged(event));
        this.filterSurveyYear.on('change', (event) => this.searchChanged(event));
        this.filterSurveyStatus.on('change', (event) => this.searchChanged(event));
        this.filterSurveyOrganizationGroup.on('change', (event) => this.searchChanged(event));
    }
}
